import React, {Component} from 'react';

class ParticleCanvas extends Component {
  canvasStyle = {
    zIndex: 2,
    position: 'absolute',
    top: 0,
    left: 0
  };

  isResize = false;
  frameId;
  particles = [];

  width = 0;
  height = 0;
  prevWidth = 0;
  prevHeight = 0;
  ctx = null;

  constructor(props) {
    super(props);
    this.state = {
      width: 0,
      height: 0
    };
  }

  componentDidMount() {
    this.updateCanvas();
    window.addEventListener('resize', this.handleResize);
  }

  componentDidUpdate() {
    const {particleCount} = this.props;

    if (this.frameId) {
      window.cancelAnimationFrame(this.frameId);
    }

    if (!this.isResize && particleCount > 0) {
      // If particle count changed and has particles
      this.particles = this.getParticles(particleCount, this.width, this.height);
    } else if (particleCount === 0) {
      // If particle count changed but no particle
      this.particles = [];
    } else {
      // Update coordinates when resize happens
      this.particles.forEach((particle) => {
        particle.updateCoordinate(this.width, this.height, this.prevWidth, this.prevHeight);
      });
    }

    if (this.isResize) {
      // Disable isResize flag if it was set to true
      this.isResize = false;
    }

    this.animateParticles(this.ctx, this.particles, this.width, this.height);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  handleResize = () => {
    this.isResize = true;
    this.updateCanvas();
  };

  updateCanvas = () => {
    const parentWidth = this.canvas.parentNode.clientWidth;
    const parentHeight = this.canvas.parentNode.clientHeight;

    this.ctx = this.canvas.getContext('2d');
    this.ctx.globalCompositeOperation = 'lighter';

    this.prevWidth = this.width;
    this.prevHeight = this.height;
    this.width = parentWidth;
    this.height = parentHeight;

    this.setState({
      width: parentWidth,
      height: parentHeight
    });
  };

  createParticle = () => {
    return {
      init(canvasWidth, canvasHeight) {
        const seedSize = Math.random();

        // Math.floor(sizeSeed * (max - min)) + min;
        this.radius = Math.floor(seedSize * (10 - 1)) + 1;

        this.opacity = (1 - seedSize) * 0.7; // multiply by 0.8 to halve the overall opacity

        this.color = `hsla(45, 0%, 100%, ${this.opacity})`;
        this.middleColor = `hsla(45, 0%, 100%, ${this.opacity})`;
        this.shadowColor = `hsla(45, 0%, 100%, 0)`;
        this.middleColorStop = seedSize >= 0.8 ? 0.2 : 1;

        this.x = Math.random() * canvasWidth;
        this.y = Math.random() * canvasHeight;

        this.direction = {
          x: -1 + Math.random() * 2,
          y: -1 + Math.random() * 2
        };

        this.vx = (5 * Math.random() + 1) * 0.01 * this.radius;
        this.vy = (5 * Math.random() + 1) * 0.01 * this.radius;
      },
      updateCoordinate(canvasWidth, canvasHeight, prevWidth, prevHeight) {
        this.x = this.x / prevWidth * canvasWidth;
        this.y = this.y / prevHeight * canvasHeight;
      },
      move() {
        this.x += this.vx * this.direction.x;
        this.y += this.vy * this.direction.y;
      },
      boundaryCheck(canvasWidth, canvasHeight) {
        if (this.x >= canvasWidth * 1.2) {
          this.x = canvasWidth * 1.2;
          this.direction['x'] *= -1
        } else if (this.x <= -canvasWidth * 0.2) {
          this.x = -canvasWidth * 0.2;
          this.direction['x'] *= -1
        }

        if (this.y >= canvasHeight * 1.2) {
          this.y = canvasHeight * 1.2;
          this.direction['y'] *= -1
        } else if (this.y <= -canvasHeight * 0.2) {
          this.y = -canvasHeight * 0.2;
          this.direction['y'] *= -1
        }
      }
    }
  };

  getParticles = (particleCount, canvasWidth, canvasHeight) => {
    const particles = [];

    while (particleCount--) {
      const particle = this.createParticle();

      particle.init(canvasWidth, canvasHeight);
      particles.push(particle);
    }

    return particles;
  };

  animateParticles = (ctx, particles, canvasWidth, canvasHeight) => {
    // Clear canvas before drawing
    ctx.clearRect(0, 0, canvasWidth, canvasHeight);

    particles.forEach((particle) => {
      this.drawParticle(ctx, particle);
    });
    particles.forEach((particle) => {
      particle.move();
      particle.boundaryCheck(canvasWidth, canvasHeight);
    });

    this.frameId = window.requestAnimationFrame(() => this.animateParticles(ctx, particles, canvasWidth, canvasHeight));
  };

  drawParticle = (ctx, particle) => {
    const {
      x,
      y,
      radius,
      color,
      middleColor,
      middleColorStop,
      shadowColor,
    } = particle;

    ctx.save();
    ctx.translate(x + (-30 * radius), y + (-10 * radius));
    const gradient = ctx.createRadialGradient(0, 0, radius, 0, 0, 0);
    gradient.addColorStop(1, color);
    gradient.addColorStop(middleColorStop, middleColor);
    gradient.addColorStop(0, shadowColor);
    ctx.beginPath();
    ctx.fillStyle = gradient;
    ctx.arc(0, 0, radius, 0, Math.PI * 2, false);
    ctx.fill();
    ctx.restore();
  };

  render() {
    return (
      <canvas
        ref={canvasRef => this.canvas = canvasRef}
        width={this.state.width}
        height={this.state.height}
        style={this.canvasStyle}>
      </canvas>
    );
  }
}

export default ParticleCanvas;


// WEBPACK FOOTER //
// ./src/app/components/organisms/ParticleCanvas/ParticleCanvas.js